const axios = require('axios').default;

export const apiCEP = axios.create({
    baseURL: "https://viacep.com.br/ws/",
    timeout: 100000
});
export default apiCEP;